<template>
  <div class="panel">
    <div class="top">
      <div class="ashGreyBgcComWrap top-warm">
        <div class="comTitleAshGreyBgc titleStart">
          <h4>{{ energyType === "ac" ? "空气源热泵" : "锅炉机组" }}</h4>
          <TitleTips :listData="dataGather?.obtainBoilerList?.title || []" />
        </div>
        <div class="comContentBoxAshGreyBgc">
          <DataPagination
            v-if="dataGather?.obtainBoilerList?.contentSwitch?.length"
            useBtnStyle
            :listData="dataGather?.obtainBoilerList?.contentSwitch"
            :className="'contentSwitch'"
            :splitNum="2"
          />
          <el-empty
            v-else
            class="empty"
            :image-size="80"
            description="暂无数据"
          ></el-empty>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="left">
        <div class="ashGreyBgcComWrap left-second">
          <div class="comTitleAshGreyBgc">
            <h4>保温水箱</h4>
          </div>
          <div class="comContentBoxAshGreyBgc">
            <DataPagination
              v-if="dataGather?.waterTank?.contentSwitch?.length"
              :listData="dataGather?.waterTank?.contentSwitch"
              className="waterToolsTipsSwitch"
              classNameTitleTipsItem="waterToolsTipsSwitchItem"
              twoLine
              :split-num="2"
            />
            <el-empty
              v-else
              class="empty-two"
              :image-size="160"
              description="暂无数据"
            ></el-empty>
          </div>
        </div>
        <div class="ashGreyBgcComWrap left-third">
          <div class="comTitleAshGreyBgc">
            <h4>环境监测</h4>
          </div>
          <div class="comContentBoxAshGreyBgc">
            <DataPagination
              v-if="dataGather?.envMonitorData?.length"
              :listData="dataGather?.envMonitorData"
              className="envMonitorDataSwitch"
              useGaugeStyle
              :chartsId="assetId"
              :split-num="4"
            />
            <el-empty
              v-else
              class="empty"
              :image-size="80"
              description="暂无数据"
            ></el-empty>
          </div>
        </div>
      </div>
      <div class="center">
        <div class="ashGreyBgcComWrap center-secondWarm">
          <div class="ashGreyBgcComWrap center-secondWarm-content">
            <div class="comTitleAshGreyBgc titleStart">
              <h4>热水循环泵</h4>
              <TitleTips :listData="dataGather?.warmWater?.title || []" />
            </div>
            <div class="comContentBoxAshGreyBgc">
              <DataPagination
                v-if="dataGather?.warmWater?.contentSwitch?.length"
                useBtnStyle
                :listData="dataGather?.warmWater?.contentSwitch"
                :className="'contentSwitch'"
                :splitNum="4"
              />
              <el-empty
                v-else
                class="empty"
                :image-size="80"
                description="暂无数据"
              ></el-empty>
            </div>
          </div>
        </div>
        <div class="ashGreyBgcComWrap center-third">
          <div class="comTitleAshGreyBgc">
            <h4>{{ energyType === "ac" ? "热泵系统能效" : "锅炉能效" }}</h4>
            <el-radio-group
              v-model="hostEnergyType"
              @change="changeHostEnergyType"
              size="mini"
            >
              <el-radio-button label="DAY">今日</el-radio-button>
              <el-radio-button label="MONTH">本月</el-radio-button>
              <el-radio-button label="YEAR">今年</el-radio-button>
            </el-radio-group>
          </div>
          <div class="comContentBoxAshGreyBgc center-third-content">
            <template
              v-if="
                activeEnergyData?.topNode?.length ||
                activeEnergyData?.bottomNode?.length
              "
            >
              <div class="center-third-content-left">
                <HeadTips
                  :listData="activeEnergyData?.topNode"
                  combineNameUnit
                  className="hostEnergyData"
                />
              </div>
              <div class="center-third-content-right">
                <Liquidfill
                  :listData="activeEnergyData?.bottomNode"
                  :assetId="assetId"
                  className="energyLiquidfill"
                />
              </div>
            </template>
            <el-empty
              v-else
              class="empty-togather"
              :image-size="80"
              description="暂无数据"
            ></el-empty>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HeadTips from "@/components/HeadTips/HeadTips";
import TitleTips from "@/components/TitleTips/TitleTips.vue";
import TitleTipsItem from "@/components/TitleTips/TitleTipsItem.vue";
import DataPagination from "@/components/zixitong/airSystem/DataPagination.vue";
import Liquidfill from "@/components/zixitong/airSystem/system/Liquidfill.vue";
import TwoYAxisBar from "@/components/zixitong/airSystem/system/TwoYAxisBar.vue";
export default {
  components: {
    HeadTips,
    TitleTips,
    TitleTipsItem,
    DataPagination,
    Liquidfill,
    TwoYAxisBar,
  },
  name: "CenterPanel",
  props: {
    dataGather: {
      type: Object,
      default: () => ({
        //保温水箱
        waterTank: {
          contentSwitch: [],
        },
        //环境监测
        envMonitorData: [],
        //主机能效
        hostEnergyData: {
          topNode: [],
          bottomNode: [],
        },
        //锅炉机组
        obtainBoilerList: {
          title: [],
          contentSwitch: [],
        },
        //热水循环泵
        warmWater: {
          title: [],
          contentSwitch: [],
        },
        //锅炉能效/热泵能效
        boilerEnergyData: {
          topNode: [],
          bottomNode: [],
        },
      }),
    },
    assetId: {
      type: String,
      default: "",
    },
    //空调模式：cool - 制冷， gc - 燃气制热， ec - 电制热， ac - 空气源热泵制热
    energyType: {
      type: String,
      default: "ac",
    },
  },
  data() {
    return {
      hostEnergyType: "DAY",
    };
  },
  computed: {
    activeEnergyData: function () {
      return this.dataGather?.boilerEnergyData;
    },
  },
  methods: {
    changeHostEnergyType() {
      if (this.energyType === "ac") {
        this.$bus.$emit(
          "getHostEnergyEfficiency",
          this.assetId,
          this.hostEnergyType
        );
      } else {
        this.$bus.$emit(
          "getBoilerEnergyEfficiency",
          this.assetId,
          this.hostEnergyType
        );
      }
    },
    //将4个value组成一组
    dealEnvMonitorData(data) {
      const newData = [];
      let obj = { name: 1, value: [] };
      Array.isArray(data) &&
        data.forEach((element, index) => {
          obj.value.push(element);
          if (index % 4 == 3) {
            newData.push(obj);
            obj = { name: index, value: [] };
          }
        });
      return newData;
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.panel {
  width: calc(100% - 40px);
  // display: flex;
  // background-color: #f7f7f7;
  padding: 0 20px;
  // @include setFlexBetween;

  .titleStart {
    @include setFlexStart;
  }
  .top {
    height: 260px;
    width: 100%;
    @include setFlexBetween;
    &-left {
      width: 49%;
      height: 100%;
    }
    &-right {
      width: 49%;
      height: 100%;
      ::v-deep .coolingTowerTips {
        width: 100%;
        height: 80px;
        margin-top: 10px;
        color: #666;

        & > div .firstDiv {
          .highlight {
            font-size: 22px;
            color: #333;
          }

          .bold {
            font-size: 16px;
          }
        }

        & > div .secondDiv {
          margin-top: 5px;
          color: #666;
          font-size: 12px;
        }
      }

      ::v-deep .coolingTowerSwitch {
        & > div:nth-child(1) > div > div:nth-child(2) {
          margin-top: 20px;
        }
      }

      ::v-deep .coolingTowerSwitchItem {
        & > div {
          width: 150px;
          justify-content: center;

          .itemValue {
            font-size: 16px;
          }
        }
      }
    }
    &-warm {
      width: 100%;
      height: 100%;
      ::v-deep .contentSwitch {
        height: 240px;
        & > div:nth-child(1) {
          height: 180px;
          justify-content: space-evenly;
          align-content: center;
          width: calc(100% - 60px);
          padding: 0 30px;
          & .datasBtnExtend {
            width: 48%;
            height: 60%;
            .datasBtn-params-item{
              min-width: 100px;
              max-width: 155px;
              width: max-content;
              margin: 0 5px;
              &-value{
                max-width: 70px;
                @include setEllipsis;
              }
            }
            & .datasBtn-name-state{
              width: 70px;
            }
          }
        }
      }
    }
  }
  .bottom {
    margin-top: 8px;
    @include setFlexBetween;
    .left {
      width: 49%;
      @include setFlexColumn;

      &-second {
        height: 350px;
        width: 100%;

        ::v-deep .waterToolsTipsSwitch {
          height: 100%;
          padding-top: 20px;

          & > div:nth-child(1) {
            height: calc(100% - 50px);
            align-items: flex-start;
            flex-direction: column;
            width: calc(100% - 40px);
            padding: 0 20px;

            & > div {
              width: 100%;
              height: 45%;
              align-items: center;
            }
          }

          & > div:nth-child(2) {
            margin-top: 5px;
          }

          & .datas {
            width: 100%;
            flex-direction: row;
            height: 40%;

            &-name {
              color: #333;
              font-size: 16px;
              font-weight: bold;
              width: 230px;
            }

            &-value {
              width: calc(100% - 230px);
            }
          }
        }

        ::v-deep .waterToolsTipsSwitchItem {
          // height: 100%;

          & > div {
            width: 150px;
            justify-content: center;
          }

          & > div .firstDiv {
            .highlight {
              font-size: 18px;
              color: #333;
            }

            .bold {
              font-size: 16px;
            }
          }

          & > div .secondDiv {
            margin-top: 5px;
            color: #666;
            font-size: 12px;
          }
        }
      }

      &-third {
        width: 100%;
        height: 250px;
      }
    }

    .center {
      width: 49%;
      @include setFlexColumn;

      &-second {
        height: 350px;
        width: 100%;
        background-color: #f7f7f7;
        @include setFlexBetween;

        &-content {
          flex-grow: 1;
          width: 306px;

          ::v-deep .contentSwitch {
            height: 280px;
            padding-top: 20px;

            & > div:nth-child(1) {
              height: 230px;
              flex-direction: column;
              justify-content: space-around;
              width: calc(100% - 40px);
              padding: 0 20px;
            }

            & > div:nth-child(2) {
              margin-top: 22px;
            }
          }

          ::v-deep .contentSwitchFullHeight > div:nth-child(1) {
            height: 100%;
          }
        }

        &-spilt {
          flex-grow: 0;
          width: 8px;
          height: 100%;
          background-color: #ffffff;
        }
      }
      &-secondWarm {
        height: 350px;
        width: 100%;
        background-color: #f7f7f7;
        // @include setFlexBetween;

        ::v-deep .contentSwitch {
          height: 280px;
          padding-top: 20px;

          & > div:nth-child(1) {
            height: 230px;
            flex-wrap: wrap;
            justify-content: space-between;
            align-content: flex-start;
            width: calc(100% - 60px);
            padding: 0 30px;
            & .datasBtnExtend {
              width: 45%;
              margin-bottom: 2%;
            }
          }
        }
      }
      &-third {
        width: 100%;
        height: 250px;

        &-content {
          @include setFlexBetween;

          &-left {
            width: 75%;
            height: 100%;

            ::v-deep .hostEnergyData {
              font-size: 12px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #666666;

              & > div {
                width: 33%;

                .firstDiv {
                  .highlight {
                    font-size: 22px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: bold;
                    color: #333333;
                  }

                  .bold {
                    font-size: 18px;
                  }
                }

                .secondDiv {
                  margin-top: 5px;
                }
              }
            }
          }

          &-right {
            width: 25%;
            height: 100%;

            ::v-deep .energyLiquidfill {
              & > div {
                width: 100%;
              }
            }
          }
        }
      }
    }
  }

  .empty-two {
    padding: 5px 0;
  }

  .empty-togather {
    width: 100%;
  }
  ::v-deep .TitleTipsItem > div .itemName{
    width: 45px;
  }
}

::v-deep .el-pagination .btn-prev,
::v-deep .el-pagination .btn-next {
  background-color: #f8fafb;
}

::v-deep .el-pagination button:disabled {
  background-color: inherit;
}

::v-deep .el-pagination .el-pager li:not(.disabled) {
  background-color: #f8fafb;
}

::v-deep .el-pagination .el-pager li:not(.disabled).active {
  background-color: #f8fafb;
}
</style>
